import { useTheme } from '@mui/material';

export default function CallNeedingAuditIcon() {
  const theme = useTheme();
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='16' fill={theme.palette.primary.light} />
      <mask
        id='mask0_41453_6012'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='7'
        y='7'
        width='18'
        height='18'
      >
        <rect x='7.38477' y='7.38464' width='17.2308' height='17.2308' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_41453_6012)'>
        <path
          d='M8.72363 22.1026L15.9997 9.53845L23.2757 22.1026H8.72363ZM10.5792 21.0256H21.4202L15.9997 11.6923L10.5792 21.0256ZM16.4111 20.0011C16.5234 19.8889 16.5796 19.7518 16.5796 19.5897C16.5796 19.4277 16.5234 19.2906 16.4111 19.1783C16.2988 19.066 16.1617 19.0098 15.9997 19.0098C15.8377 19.0098 15.7005 19.066 15.5883 19.1783C15.4759 19.2906 15.4198 19.4277 15.4198 19.5897C15.4198 19.7518 15.4759 19.8889 15.5883 20.0011C15.7005 20.1135 15.8377 20.1697 15.9997 20.1697C16.1617 20.1697 16.2988 20.1135 16.4111 20.0011ZM15.4612 18.2919H16.5381V14.7021H15.4612V18.2919Z'
          fill={theme.palette.primary.main}
        />
      </g>
    </svg>
  );
}
